import { stateCity, regional, unity } from '../../modules/select';
import { dateRange } from '../../modules/dateRange';
import { userSubscribe } from '../../modules/userSubscribe';
import { _filter } from './_filter';

export const challengesSearch = () => {
  dateRange('up');
  stateCity();
  regional();
  unity();
  userSubscribe();
  _filter();
};
